import React from "react";
import styled from "styled-components";

const black = "#0d0d0d";
const blackSoft = "#141414";
const green = "#2a960d";
const greenBright = "#37c313";
const greenDark = "#1e7009";
const text = "#f2f2f2";
const textMuted = "#a8a8a8";

const Page = styled.main`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 20px;

  @media (max-width: 480px) {
    padding: 32px 14px;
  }
`;

const ErrorCard = styled.section`
  width: 100%;
  max-width: 560px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 48px 36px;
  background-color: ${blackSoft};
  border: 1px solid ${green};
  border-radius: 8px;

  @media (max-width: 480px) {
    padding: 36px 22px;
    gap: 14px;
  }
`;

const IconWrapper = styled.div`
  color: ${greenBright};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;

  .spark {
    stroke-width: 2.5;
    opacity: 0.8;
  }
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  color: ${text};

  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`;

const Message = styled.p`
  font-size: 1.05rem;
  line-height: 1.6;
  color: ${text};
  max-width: 42ch;

  @media (max-width: 480px) {
    font-size: 0.98rem;
  }
`;

const Hint = styled.p`
  font-size: 0.95rem;
  line-height: 1.5;
  color: ${textMuted};
  max-width: 44ch;

  @media (max-width: 480px) {
    font-size: 0.88rem;
  }
`;

const Button = styled.button`
  margin-top: 16px;
  appearance: none;
  border: none;
  border-radius: 6px;
  background-color: ${green};
  color: #fff;
  font-size: 1.05rem;
  font-weight: 600;
  font-family: inherit;
  letter-spacing: 0.02em;
  padding: 16px 40px;
  min-height: 52px;
  min-width: 220px;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    transform 0.1s ease;

  &:hover {
    background-color: ${greenBright};
  }

  &:active {
    background-color: ${greenDark};
    transform: scale(0.97);
  }

  &:focus-visible {
    outline: 3px solid ${greenBright};
    outline-offset: 3px;
  }

  @media (max-width: 480px) {
    width: 100%;
    min-width: 0;
    padding: 15px 24px;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;

    &:active {
      transform: none;
    }
  }
`;

export default function MainNotFound() {
  const handleGoHome = () => {
    window.location.href = "/";
  };

  return (
    <>
      <style>
        {`

      body{
          background-color: #0d0d0d!important;
      }

      .App{
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        }
      `}
      </style>

      <Page>
        <ErrorCard role="alert" aria-labelledby="error-title">
          <IconWrapper aria-hidden="true">
            <svg
              viewBox="0 0 96 96"
              width="88"
              height="88"
              fill="none"
              stroke="currentColor"
              strokeWidth="3.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M40 30 L30 40 a14 14 0 0 0 0 20" />
              <path d="M56 66 L66 56 a14 14 0 0 0 0 -20" />
              <path d="M38 44 l8 8" opacity="0.35" />
              <path d="M54 36 l4 -4" />
              <path d="M44 62 l-4 4" />
              <line x1="60" y1="20" x2="66" y2="14" className="spark" />
              <line x1="70" y1="30" x2="78" y2="27" className="spark" />
              <line x1="30" y1="70" x2="24" y2="76" className="spark" />
              <line x1="20" y1="62" x2="13" y2="65" className="spark" />
            </svg>
          </IconWrapper>

          <Title id="error-title">Página não encontrada</Title>

          <Message>
            A página que você está tentando acessar não existe ou não está mais
            disponível.
          </Message>
          <Hint>
            Verifique o endereço informado ou volte para a página inicial.
          </Hint>

          <Button type="button" onClick={handleGoHome}>
            Voltar para o início
          </Button>
        </ErrorCard>
      </Page>
    </>
  );
}
